// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"0c80dae2","174":"d04358e3","690":"ed5b1d24","861":"9601aa90"}[chunkId] + ".chunk.css";
};